<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getPayments"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons>
        <b-button
          @click="showCreatePayment = true"
          class="ml-2"
          variant="primary"
        >
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:headings>
        <div class="col-md-1">Payment</div>
        <div class="col-md-2">Created</div>
        <div class="col-md-3">Entity</div>
        <div class="col-md-2">Reference</div>
        <div class="col-md-2">Amount</div>
        <div class="col-md-2">Type</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-1 my-auto">
          <p class="m-0">{{ slotProps.item.payment_number }}</p>
        </div>

        <div class="col-md-2 my-auto">
          {{ moment(new Date(slotProps.item.created_at)).format("DD MMM YY") }}
        </div>

        <div class="col-md-3 my-auto" v-if="slotProps.item.client_id">
          <router-link
            v-b-tooltip.hover
            title="view client"
            :to="{
              name: 'clients-show',
              params: { id: slotProps.item.client_id },
            }"
            class="text-primary font-weight-bold"
          >
            <u>
              <strong>
                {{
                  slotProps.item.client.name +
                  " " +
                  slotProps.item.client.surname
                }}</strong
              >
            </u>
          </router-link>
          <small class="text-muted font-size-11">(Client)</small>
        </div>

        <div class="col-md-3 my-auto" v-if="slotProps.item.partner_id">
          <router-link
            v-b-tooltip.hover
            title="view partner"
            :to="{
              name: 'partners-show',
              params: { id: slotProps.item.partner_id },
            }"
            class="text-primary font-weight-bold"
          >
            <u>
              <strong>{{ slotProps.item.partner.name }}</strong>
            </u>
          </router-link>

          <small class="text-muted font-size-11">(Partner)</small>
        </div>

        <div class="col-md-3 my-auto" v-if="slotProps.item.supplier_id">
          <router-link
            v-b-tooltip.hover
            title="view supplier"
            :to="{
              name: 'suppliers-show',
              params: { id: slotProps.item.supplier_id },
            }"
            class="text-primary font-weight-bold"
          >
            <u>
              <strong>{{ slotProps.item.supplier.name }}</strong>
            </u>
          </router-link>

          <small class="text-muted font-size-11">(Supplier)</small>
        </div>

        <div class="col-md-2 my-auto">
          <p class="m-0">
            {{ slotProps.item.reference }}
          </p>
        </div>

        <div class="col-md-2 my-auto">
          <p class="m-0 text-primary">
            {{ slotProps.item.transaction_amount | currency }}
          </p>
        </div>

        <div
          class="col-md-2 my-auto pt-3 pt-md-0"
          v-if="slotProps.item.payment_type"
        >
          {{ slotProps.item.payment_type.type }}
        </div>
      </template>
    </data-table>

    <b-modal
      @hidden="refresh"
      :hide-footer="true"
      title="Create Payment"
      size="lg"
      v-model="showCreatePayment"
      :no-close-on-route-change="true"
      :lazy="true"
    >
      <payment-create></payment-create>
    </b-modal>
  </div>
</template>

<script>
import accountRepo from "@/api/repos/accountRepo";
import dataTable from "@/components/common/DataTable";
import paymentCreate from "@/views/modules/accounts/paymentCreate";

export default {
  props: ["accountId"],

  components: {
    paymentCreate,
    dataTable,
  },

  data() {
    return {
      showCreatePayment: false,
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "created_at", label: "Latest", order: "desc" },
      sortOptions: [
        { column: "created_at", label: "Oldest", order: "asc" },
        { column: "created_at", label: "Latest", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getPayments({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      search: "",
    });
  },
  methods: {
    refresh() {
      this.getPayments({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 10,
        search: "",
      });
    },
    async getPayments(e) {
      this.isLoad = true;
      try {
        let { data } = await accountRepo.payments(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.payments.data;
        this.totalRows = data.payments.total;
        this.page = data.payments.current_page;
        this.fromRow = data.payments.from;
        this.toRow = data.payments.to;
        this.lastPage = data.payments.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
